import { useTranslations } from "next-intl";
import styles from "./facilities-selector.module.css";
import { Facilities, PurposeEnum, TypeEnum } from "@/types/types";
import {
  facilityRules,
  getAvailableFacilities,
} from "@/lib/getFacilities/getAvailableFacilities";
import { useEdittingStore } from "../context/useEdittingStore";

export default function FacilitiesSelector({
  facilitiesValue,
  hasLuxuryFinishesValue,
  error,
  type,
  purpose,
}: {
  facilitiesValue: Facilities;
  hasLuxuryFinishesValue: boolean;
  error: string | undefined;
  type: TypeEnum;
  purpose: PurposeEnum;
}) {
  const t = useTranslations("NewListing.Facilities");
  const facilities = getAvailableFacilities(type, purpose);
  const setField = useEdittingStore((state) => state.setField);

  return (
    <div className={styles.inputItem}>
      <h3 className={`${styles.fieldTitle} ${error && styles.error}`}>
        {t("facilitiesTitle")}
      </h3>
      <p className={styles.fieldDescription}>{t("facilitiesDescription")}</p>
      <ul className={styles.wrapper}>
        {(type === TypeEnum.HOUSE || type === TypeEnum.APARTMENT) && (
          <li>
            <button
              onClick={(e) => {
                e.preventDefault();
                setField("has_luxury_finishes", !hasLuxuryFinishesValue);
              }}
              className={`${styles.pill} ${
                hasLuxuryFinishesValue ? styles.active : ""
              }`}
              aria-pressed={hasLuxuryFinishesValue}
            >
              {t("luxury-finishes")}
            </button>
          </li>
        )}
        {facilities.map((facility, index) => {
          return (
            <li key={index}>
              <button
                onClick={(e) => {
                  e.preventDefault();
                  setField("facilities", {
                    ...facilitiesValue,
                    [facility]: !facilitiesValue?.[facility],
                  });
                }}
                className={`${styles.pill} ${
                  styles[facilityRules[facility].color]
                } ${facilitiesValue?.[facility] ? styles.active : ""}`}
                aria-pressed={facilitiesValue?.[facility]}
              >
                {t(facilityRules[facility].label)}
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
